var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:_vm.key},[(_vm.showSpinner)?_c('Spinner',{attrs:{"options":_vm.spinnerOptions}}):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }